var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
// A <span> containing a continuously-updating "loading ellipsis" (i.e. the text
// changes from "" -> "." -> ".." -> "..." and repeats). Note that the 3 dots
// are always rendered, but `visibility: hidden` is set when a dot should not be
// shown. This ensures that the text's and container's width remain static, as
// otherwise there may be slight shifts in positioning every update.
export var LoadingEllipsisText = function (_a) {
    var _b = _a.updateFrequencyMs, updateFrequencyMs = _b === void 0 ? 600 : _b;
    var _c = useState(0), numShown = _c[0], setNumShown = _c[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setNumShown(function (prevNumShown) {
                // Currently hardcoded for 3 dots, but we could update this to support
                // an arbitrary number of dots if the use case ever arises.
                return prevNumShown === 3 ? 0 : prevNumShown + 1;
            });
        }, updateFrequencyMs);
        return function () { return clearInterval(interval); };
    }, [updateFrequencyMs]);
    return (React.createElement("span", { style: __assign({}, (numShown < 1 && {
            visibility: 'hidden',
        })) },
        ".",
        React.createElement("span", { style: __assign({}, (numShown < 2 && {
                visibility: 'hidden',
            })) }, "."),
        React.createElement("span", { style: __assign({}, (numShown < 3 && {
                visibility: 'hidden',
            })) }, ".")));
};
